import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';
import { Field } from './form.lib';
import { ValidatorResponse } from './Validators';
import { get } from 'lodash';

export class ValidatorComponent extends React.Component<{field: Field, icon?: string}, any> {
    public field: Field = this.props.field;
    public state = {
        error: null
    };

    private style = {width: '35px', background: 'red', color: 'white', display: 'flex'};

    componentWillMount() {
        this.field.onError$.subscribe((errors: ValidatorResponse[]) => {
            this.setState({
                error: errors.length ? errors[0] : null
            });
        });
    }

    render() {
        return this.state.error && (
            <div className="input-group-addon" style={this.style} data-tip={this.state.error ? (this.state.error as any).message : ''}>
                <i className={get(this.props, 'icon', 'fa fa-close')}/>
                <ReactTooltip/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/validator.component.tsx